import React from 'react';
import parser from 'html-react-parser';
import Text from '../../../../../components/Text';
import Block from '../../../../../components/Block';

const Heading = (props: any) => {
  const { title, subtitle, titleWrap } = props;
  // Sólo puedes subir en formato {getFileFormat()}. (Tamaño máximo
  //     de archivo: {maxFileSize} MB) .

  return (
    <Block customized>
      <Block customized>
        <Text
          fontSize="14px"
          lineHeight="20px"
          fontWeight="700"
          textAlign="left"
          whiteSpace={titleWrap || 'initial'}
        >
          {title}
        </Text>
      </Block>
      <Block customized>
        <Text
          fontSize="14px"
          lineHeight="20px"
          fontWeight="400"
          textAlign="left"
        >
          {parser(subtitle)}
        </Text>
      </Block>
    </Block>
  );
};

export default Heading;
